import "./LoaderSpinner.css";

export default function LoaderSpinner({
    size = "md",
    label,
    fullPage = false,
}) {
    const className = [
        "loader-spinner",
        `loader-spinner--${size}`,
        fullPage && "loader-spinner--full-page",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div
            className={className}
            role="status"
            aria-live="polite"
            aria-label={label || "Chargement en cours"}
        >
            <div className="loader-spinner__orbit">
                <span className="loader-spinner__ring" />
                <span className="loader-spinner__ring loader-spinner__ring--secondary" />
                <div className="loader-spinner__dots" aria-hidden="true">
                    <span className="loader-spinner__dot" />
                    <span className="loader-spinner__dot" />
                    <span className="loader-spinner__dot" />
                </div>
                <span className="loader-spinner__core" />
            </div>
            {label && <p className="loader-spinner__label">{label}</p>}
        </div>
    );
}
